import { render, staticRenderFns } from "./UserView.vue?vue&type=template&id=fffba6ec&"
import script from "./UserView.js?vue&type=script&lang=js&"
export * from "./UserView.js?vue&type=script&lang=js&"
import style0 from "./UserView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports